import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Tabs } from '@ui/components/Tabs';

import { SwissSettings } from '@features/shared/api/typings';
import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const OPTIONS: {
  value: SwissSettings['seedNumberAllocationType'];
  label: string;
  disabled?: boolean;
}[] = [
  { value: 'ByElo', label: 'По рейтингу' },
  { value: 'ByNumberInTournament', label: 'По порядку' },
];

export function SwissSeedInput() {
  const { control } = useFormContext<TournamentEditFormValues>();

  return (
    <FormRow>
      <FormLabel>Жеребьёвка</FormLabel>
      <FormInput>
        <Controller
          name="swissSettings.seedNumberAllocationType"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Tabs tabs={OPTIONS} value={value} onChange={onChange} disabled={disabled} />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
